import { render } from "./SupplierReceiptView.vue?vue&type=template&id=3f671acb&scoped=true"
import script from "./SupplierReceiptView.vue?vue&type=script&lang=js"
export * from "./SupplierReceiptView.vue?vue&type=script&lang=js"

import "./SupplierReceiptView.vue?vue&type=style&index=0&id=3f671acb&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./SupplierReceiptView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f671acb"]])

export default __exports__